const canvas = document.createElement('canvas')
const ctx = canvas.getContext('2d')

const truncate = (text, chartsLimit) => {
  return text.length > chartsLimit ? `${text.slice(0, chartsLimit).trim()}...` : text
}

const truncateText = ({
  text,
  el,
  stringsLimit,
  chartsLimit = undefined,
}: {
  text: string
  el?: Element | string
  stringsLimit?: number
  chartsLimit?: number
}) => {
  const textLength = text.length
  if (!el) {
    return truncate(text, chartsLimit)
  }
  let container
  if (typeof el === 'string') {
    container = document.querySelector(el)
  } else if (el instanceof Element) {
    container = el
  }
  if (container) {
    const containerStyles = window.getComputedStyle(container)
    const letterSpacing = parseFloat(containerStyles['letter-spacing'])
    const blockWidthOffset = container.offsetWidth
    const blockLeftPadding = parseFloat(containerStyles['padding-left'])
    const blockRightPadding = parseFloat(containerStyles['padding-right'])
    const blockWithoutPaddings = blockWidthOffset - (blockLeftPadding + blockRightPadding)
    ctx.font = containerStyles.font
    const textWidth = ctx.measureText(text).width
    const oneSymbolSize = Math.ceil(textWidth / textLength)
    const oneSymbolWithSpacing = oneSymbolSize + letterSpacing
    const symbolsPerString = blockWithoutPaddings / Math.ceil(oneSymbolWithSpacing)
    const maxSymbolsPerBlock = Math.floor(symbolsPerString * stringsLimit)
    return truncate(text, maxSymbolsPerBlock)
  } else if (process.env.NODE_ENV !== 'production') {
    throw new Error(`Element wasn't found`)
  }
  return text
}
export default truncateText
